import { render, staticRenderFns } from "./CarouselMessage.vue?vue&type=template&id=626b03aa"
import script from "./CarouselMessage.vue?vue&type=script&lang=js"
export * from "./CarouselMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports